import React from 'react';

import combinedActions from '~redux/combinedActions';
import { useAppDispatch, useAppSelector } from '~redux/hooks';

import { TCreateNewCustomerReduxParams } from '~types/feat/customer';

import Modal from '~components/atoms/Modal';
import CustomerManagementCreateCustomerForm from '../CustomerManagementCreateCustomerForm';

const CustomerManagementCreateCustomerModal = () => {
    const dispatch = useAppDispatch();

    const isOpen = useAppSelector(state => state.customer.modals.createNewCustomerModalIsOpen);
    const isLoading = useAppSelector(state => state.customer.loadings.createNewCustomer);
    const error = useAppSelector(state => state.customer.errors.createNewCustomer);

    const handleModalOnClose = () => {
        dispatch(combinedActions.customerResetCreateNewCustomerState());
        dispatch(combinedActions.customerSetCreateNewCustomerModalIsOpen(false));
    };

    const handleOnSubmit = (data: TCreateNewCustomerReduxParams) => !isLoading && dispatch(combinedActions.customerCreateNewCustomerAttempt(data));

    return (
        <Modal
            testId='create-customer-modal-close'
            title='Create Customer'
            isOpen={isOpen}
            onClose={handleModalOnClose}
        >
            <CustomerManagementCreateCustomerForm
                submitButtonLabel='Create Customer'
                onSubmit={handleOnSubmit}
                actionButtonIsLoading={isLoading}
                error={error}
            />
        </Modal>
    );
};

export default CustomerManagementCreateCustomerModal;
